module.exports = __webpack_public_path__ + "img/naturstrom-blue-p-500.a4575253.jpeg";